App.directive('tldSearchClick', function($rootScope, domainService) {
	return {
		// require the form to check if it's valid
		require: '^form',
		restrict: 'A',
		scope: {
			searchFunction: '&tldSearchClick'
		},
		link: function(scope, el, attrs, ctrl) {
			// handle enter key
			el.on('click', function(e) {
				//initialize popover
				var model = 'formData.domain',
					viewValue = $rootScope.formData.domain,
					searchFunction = scope.searchFunction(),
					sanitizedResult,
					regex;

				$rootScope.showAlerts = false;
				$rootScope.selectedDomain = null;
				$rootScope.domainError = false;
				$rootScope.showTitle = '';
				$rootScope.showSubtitle = '';

				if (typeof viewValue == 'undefined') {
					// cancel current call
					domainService.stop();
					return;
				}

				void 0;

				if (viewValue.length === 0) {
					$rootScope.formDomain.$setPristine();
				}

				// properly format our domain
				sanitizedResult = domainService.sanitizeDomainSearch(viewValue, $rootScope.currentBundle, $rootScope.anytld);
				viewValue = sanitizedResult[0];
				regex = sanitizedResult[1];

				// i really hate doing this, because its specific and not dynamic, but here it goes:
				$rootScope.formData.domain = viewValue;

				//validate it
				if (regex.test(viewValue)) {
					// it is valid
					ctrl.$setValidity('validUrl', true);
				} else {
					// it is invalid
					ctrl.$setValidity('validUrl', false);
					domainService.stop();
				}
				
				// finally, check if viewvalue length >= 2
				searchFunction(false);
            });
		}
	}
});

/**
 * tld-search  directive.
 * params: tld-search
 */
App.directive('tldSearchEvent', function($rootScope, domainService){
	return {
		// require the form to check if it's valid
		require: '^form',
		restrict: 'A',
		scope: {
			searchFunction: '&tldSearchEvent',
			ngModel: '&',
		},
		link: function(scope, el, attrs, ctrl) {
			var model = 'formData.domain',
				searchFunction = scope.searchFunction(),
				viewValue,
				sanitizedResult,
				regex;

			el.on('keydown', function(e) {
				var viewValue;

				if (e.keyCode == 13) {
					viewValue = $(e.currentTarget).val();

					void 0;
					void 0;

					$rootScope.showAlerts = false;
					$rootScope.selectedDomain = null;
					$rootScope.domainError = false;
					$rootScope.showTitle = '';
					$rootScope.showSubtitle = '';

					if (typeof viewValue != 'undefined') {
						if (viewValue.length === 0) {
							$rootScope.formDomain.$setPristine();
						}

						// properly format our domain
						sanitizedResult = domainService.sanitizeDomainSearch(viewValue, $rootScope.currentBundle, $rootScope.anytld);
						viewValue = sanitizedResult[0];
						regex = sanitizedResult[1];

						// i really hate doing this, because its specific and not dynamic, but here it goes:
						$rootScope.formData.domain = viewValue;

						// validate it
						if (regex.test(viewValue)) {
							// it is valid
							ctrl.$setValidity('validUrl', true);
						} else {
							// it is invalid
							ctrl.$setValidity('validUrl', false);
							domainService.stop();
						}
						
						// finally, check if viewvalue length >= 2
						searchFunction(false);
					} else {
						// cancel current call
						domainService.stop();
					}
				}
			});
		}
	}
});

/**
 * tld-search  directive.
 * params: tld-search
 */
App.directive('tldSearch', function($rootScope, domainService){
	return {
		require: 'ngModel',
		restrict: 'A',
		scope: {
			searchFunction: '&tldSearch',
			ngModel: '&'
		},
		link: function(scope,el,attrs,ctrl) {
			var model = attrs.ngModel,
				searchFunction = scope.searchFunction(),
				sanitizedResult,
				regex;

			// watch for scope changes on the input model
			$rootScope.$watch(attrs.ngModel, function(viewValue) {
				$rootScope.showAlerts = false;
				$rootScope.selectedDomain = null;
				$rootScope.domainError = false;
				$rootScope.showTitle = '';
				$rootScope.showSubtitle = '';

				if (typeof viewValue != 'undefined') {
					if(viewValue.length === 0) {
						$rootScope.formDomain.$setPristine();
					}

					// properly format our domain
					sanitizedResult = domainService.sanitizeDomainSearch(viewValue, $rootScope.currentBundle, $rootScope.anytld);
					viewValue = sanitizedResult[0];
					regex = sanitizedResult[1];

					// i really hate doing this, because its specific and not dynamic, but here it goes:
					$rootScope.formData.domain = viewValue;

					//validate it
					if (regex.test(viewValue)) {
						// it is valid
						ctrl.$setValidity('validUrl', true);
					} else {
						// it is invalid
						ctrl.$setValidity('validUrl', false);
						domainService.stop();
					}
					
					// finally, check if viewvalue length >= 2
					searchFunction(true);
				} else {
					// cancel current call
					domainService.stop();
				}

			});
		}
	}
});
